import { render } from "./ResetPassword.vue?vue&type=template&id=1da614ac"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1da614ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1da614ac', script)) {
    api.reload('1da614ac', script)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=1da614ac", () => {
    api.rerender('1da614ac', render)
  })

}

script.__file = "resources/js/Pages/Auth/ResetPassword.vue"

export default script